import { useState } from 'react'
import { Link, router } from '@inertiajs/react'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import { Loader2 } from 'lucide-react'
import type { GoogleAccountOption } from '@/frontend/pages/Dashboard/DigitalWorkers/types'

interface Props {
  open: boolean
  onOpenChange: (open: boolean) => void
  workerId: string
  metaAdAccounts: GoogleAccountOption[]
}

export default function MetaAccountsModal({ open, onOpenChange, workerId, metaAdAccounts }: Props) {
  const [selectedIds, setSelectedIds] = useState<string[]>(
    metaAdAccounts.filter((a) => a.selected).map((a) => String(a.id))
  )
  const [saving, setSaving] = useState(false)

  const handleOpen = (isOpen: boolean) => {
    if (isOpen) {
      setSelectedIds(metaAdAccounts.filter((a) => a.selected).map((a) => String(a.id)))
    }
    onOpenChange(isOpen)
  }

  const toggle = (id: string) => setSelectedIds((prev) => prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id])

  const handleSave = () => {
    setSaving(true)
    router.post(`/dashboard/digital_workers/${workerId}/update_meta_accounts`, {
      ad_account_ids: selectedIds,
    }, {
      preserveScroll: true,
      onSuccess: () => onOpenChange(false),
      onFinish: () => setSaving(false),
    })
  }

  return (
    <Dialog open={open} onOpenChange={handleOpen}>
      <DialogContent className="max-w-[600px]">
        <DialogHeader>
          <DialogTitle>Selecionar Contas de Anúncio Meta</DialogTitle>
        </DialogHeader>
        <div className="space-y-6">
          <div>
            <p className="text-sm font-medium text-foreground mb-3">Contas de Anúncio</p>
            {metaAdAccounts.length > 0 ? (
              <div className="space-y-2">
                {metaAdAccounts.map((account) => (
                  <div key={account.id} className="flex items-center gap-2">
                    <Checkbox id={`meta-${account.id}`} checked={selectedIds.includes(String(account.id))} onCheckedChange={() => toggle(String(account.id))} />
                    <Label htmlFor={`meta-${account.id}`} className="text-sm font-normal">{account.name} ({account.external_id})</Label>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-sm text-muted-foreground">
                Nenhuma conta de anúncio Meta encontrada.{' '}
                <Link href="/dashboard/integrations/meta" className="text-foreground hover:underline">Configurar integração Meta</Link>
              </p>
            )}
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button onClick={handleSave} disabled={saving}>
            {saving && <Loader2 className="h-4 w-4 animate-spin" />}
            Salvar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
